import { Skeleton } from '@neo/primitives/skeleton'

export const AgentCanvasLoading = () => (
  <section
    className="flex h-full min-h-64 flex-col items-center justify-center gap-6 bg-bg2 p-6"
    aria-busy="true"
    aria-label="Loading agent flow"
    data-testid="loading-agent-canvas"
  >
    <div className="w-56 rounded-lg border border-border bg-background p-4">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="mt-3 h-3 w-40" />
    </div>
    <div className="h-8 w-px bg-border" aria-hidden="true" />
    <div className="w-64 rounded-lg border border-border bg-background p-4">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="mt-3 h-3 w-48" />
      <Skeleton className="mt-2 h-3 w-40" />
    </div>
  </section>
)

export const AgentBuilderLoading = () => (
  <section
    className="flex h-full flex-col bg-bg2"
    aria-busy="true"
    aria-label="Loading agent"
    data-testid="loading-agent-builder"
  >
    <div className="flex items-center justify-between border-b border-border bg-background px-6 py-4">
      <Skeleton className="h-6 w-48" />
      <Skeleton className="h-8 w-24" />
    </div>
    <div className="flex gap-4 overflow-hidden border-b border-border bg-background px-6 py-3">
      {['flow', 'goals', 'runs', 'settings'].map((tab) => (
        <Skeleton key={tab} className="h-4 w-24" />
      ))}
    </div>
    <div className="m-3 mt-0 flex-1 overflow-hidden rounded-lg border border-border">
      <AgentCanvasLoading />
    </div>
  </section>
)
